import styled, { css } from 'styled-components';
import { SelectSize, SelectVariant } from '.';

type ContainerProps = {
  $size: SelectSize;
  $variant: SelectVariant;
  $color: string;
  $error: boolean | string;
};

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing['1']}px;
  min-height: 86px;
`;

export const Container = styled.button<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${({ theme, $variant, $color }) => {
    if (['ghost', 'surface'].includes($variant)) return 'transparent';
    return theme.colors[$color][`${$color}_alpha`][3];
  }};

  cursor: pointer;

  ${({ theme, $size }) => {
    if ($size === 1) {
      return css`
        padding: ${theme.spacing[$size + 1]}px;
      `;
    }
    return css`
      padding-top: ${theme.spacing[$size + 1]}px;
      padding-right: ${theme.spacing[$size]}px;
      padding-bottom: ${theme.spacing[$size + 1]}px;
      padding-left: ${theme.spacing[$size]}px;
    `;
  }}

  border: 2px solid ${({ theme, $variant, $error }) => {
    if ($variant === 'soft') return 'transparent';
    if ($error) return theme.colors.semantic.error['9'];
    return theme.colors.neutral.neutral_alpha['5'];
  }};

  gap: ${({ theme, $size }) => theme.spacing[$size]}px;

  &:hover {
    ${({ theme, $error, $variant, $color }) => {
      if ($error) return '';
      if ($variant === 'soft') return '';
      return css`
        border-color: ${theme.colors[$color][`${$color}_alpha`][8]};
      `;
    }}
  }

  border-radius: ${({ theme }) => theme.radius['3']}px;
`;

export const Input = styled.input<{ $error: boolean }>`
  width: 100%;
  resize: horizontal;

  cursor: pointer;

  background: none;

  padding-right: ${({ theme }) => theme.spacing[1]}px;
  padding-left: ${({ theme }) => theme.spacing[1]}px;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.regular};
      line-height: ${theme.typography.font.line_height[3]}px;
      text-align: left;
      color: ${theme.colors.neutral.neutral[12]};

      &::placeholder {
        font-size: ${theme.typography.font.size[3]}px;
        font-family: var(--font-${theme.typography.font.family.text});
        font-weight: ${theme.typography.font.weight.medium};
        line-height: ${theme.typography.font.line_height[3]}px;
        text-align: left;
        color: ${theme.colors.neutral.neutral_alpha[9]};
      }
    `;
  }};
`;
